<template>
  <a-modal :title="$t('edit')" :visible="visible" @cancel="onClose">
    <a-form :form="form" :label-col="{ span: 7 }" :wrapper-col="{ span: 14 }">
      <a-form-item :label="$t('page_material_customer_code')">
        <a-input
          style="width: 100%"
          :placeholder="$t('common_please_input') + $t('page_material_customer_code')"
          disabled
          v-decorator="[
            'code',
            {
              initialValue: item.code || '',
              rules: [
                {
                  required: true,
                  max: 48,
                  message: $t('page_material_warehousing_custom_input48'),
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_material_customer_name')">
        <a-auto-complete
          :data-source="dataSource"
          style="width: 100%"
          @search="onSearchCustomer"
          :placeholder="$t('common_please_input') + $t('page_material_customer_name')"
          v-decorator="[
            'name',
            {
              initialValue: item.name || '',
              rules: [
                {
                  required: true,
                  max: 48,
                  message: $t('page_material_warehousing_custom_input48'),
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_tenant_contacts')">
        <a-input
          v-decorator="[
            'contact',
            {
              initialValue: item.contact || '',
            },
          ]"
          :placeholder="$t('common_please_input') + $t('page_tenant_contacts')"
        />
      </a-form-item>
      <a-form-item :label="$t('page_tenant_contact_number')">
        <a-input
          v-decorator="[
            'tel',
            {
              initialValue: item.tel || '',
            },
          ]"
          :placeholder="$t('common_please_input') + $t('page_tenant_contact_number')"
        />
      </a-form-item>
      <a-form-item :label="$t('page_ops_customer_province')">
        <a-select
          :placeholder="$t('please_select') + $t('page_ops_customer_province')"
          show-search
          :filter-option="filterOption"
          v-decorator="[
            'provinceId',
            {
              initialValue: editProvince,
              rules: [{ required: true, message: $t('please_select') + $t('page_ops_customer_province') }],
            },
          ]"
          @change="handleProvinceChange"
        >
          <a-select-option
            :key="province.code"
            :value="province.code"
            v-for="province in provinceList"
          >
            {{ province.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_ops_customer_city')">
        <a-select
          :placeholder="$t('please_select') + $t('page_ops_customer_city')"
          show-search
          :filter-option="filterOption"
          v-decorator="[
            'cityId',
            {
              initialValue: editCity,
              rules: [{ required: true, message: $t('please_select') + $t('page_ops_customer_city') }],
            },
          ]"
          @change="handleCityChange"
        >
          <a-select-option
            :key="city.code"
            :value="city.code"
            v-for="city in cityList"
          >
            {{ city.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_ops_customer_detailed_address')">
        <a-textarea
          :placeholder="$t('common_please_input') + $t('page_ops_customer_detailed_address')"
          v-decorator="[
            'address',
            {
              initialValue: item.address || '',
              rules: [{ required: true, message: $t('common_please_input') + $t('page_ops_customer_detailed_address') }],
            },
          ]"
          :auto-size="{ minRows: 3, maxRows: 5 }"
        />
      </a-form-item>
      <a-form-item :label="$t('page_ops_customer_data_permissions')">
        <a-tree-select
          show-search
          tree-node-filter-prop="title"
          v-decorator="[
            'createDept',
            {
              initialValue: item.createDept || '',
              rules: [{ required: true, message: $t('please_select') + $t('page_ops_customer_data_permissions') }],
            },
          ]"
          style="width: 100%"
          :tree-data="treeData"
          :multiple="false"
          :placeholder="$t('please_select') + $t('page_ops_customer_data_permissions')"
        />
      </a-form-item>
      <a-form-item :label="$t('page_material_more') + '1'">
        <a-input
          style="width: 100%"
          :placeholder="$t('common_please_input') + $t('page_material_more') + '1'"
          v-decorator="[
            'extend1',
            {
              initialValue: item.extend1 || '',
              rules: [
                {
                  max: 48,
                  message: $t('page_material_warehousing_custom_more48'),
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_material_more') + '2'">
        <a-input
          style="width: 100%"
          :placeholder="$t('common_please_input') + $t('page_material_more') + '2'"
          v-decorator="[
            'extend2',
            {
              initialValue: item.extend2 || '',
              rules: [
                {
                  max: 48,
                  message: $t('page_material_warehousing_custom_more48'),
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_material_more') + '3'">
        <a-input
          style="width: 100%"
          :placeholder="$t('common_please_input') + $t('page_material_more') + '3'"
          v-decorator="[
            'extend3',
            {
              initialValue: item.extend3 || '',
              rules: [
                {
                  max: 48,
                  message: $t('page_material_warehousing_custom_more48'),
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_material_more') + '4'">
        <a-input
          style="width: 100%"
          :placeholder="$t('common_please_input') + $t('page_material_more') + '4'"
          v-decorator="[
            'extend4',
            {
              initialValue: item.extend4 || '',
              rules: [
                {
                  max: 48,
                  message: $t('page_material_warehousing_custom_more48'),
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_material_more') + '5'">
        <a-input
          style="width: 100%"
          :placeholder="$t('common_please_input') + $t('page_material_more') + '5'"
          v-decorator="[
            'extend5',
            {
              initialValue: item.extend5 || '',
              rules: [
                {
                  max: 48,
                  message: $t('page_material_warehousing_custom_more48'),
                },
              ],
            },
          ]"
        />
      </a-form-item>
    </a-form>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button @click="onClose" style="margin-right: 8px;" type="default">{{
        $t("cancel")
      }}</a-button>
      <a-button :loading="loading" @click="save" type="primary">{{
        $t("save")
      }}</a-button>
    </div>
  </a-modal>
</template>
<script>
import { CodeRuleServiceProxy } from "@/service-proxies/app-v2/code.service-proxies";
import { CustomerServiceProxy } from "@/service-proxies/app-v2/client.service-proxies";
import {
  AuthorityDomainServiceProxy,
  RegionServiceProxy,
} from "@/service-proxies/app-v2/system.service-proxies";
const ctsp = new CustomerServiceProxy();

const crsp = new CodeRuleServiceProxy();
const adsp = new AuthorityDomainServiceProxy();
const rsp = new RegionServiceProxy();

import R from "ramda";

const resetProp = (from, to) => R.pipe(R.prop(from), R.objOf(to));

const tranformTreeShape = (data) => {
  const setLabel = resetProp("title", "label");
  const setValue = resetProp("id", "value");
  const setChildren = R.pipe(
    R.prop("children"),
    R.ifElse(
      R.either(R.isNil, R.isEmpty),
      R.empty,
      R.pipe(R.map(tranformTreeShape), R.objOf("children"))
    )
  );

  return R.converge(R.unapply(R.mergeAll), [setLabel, setValue, setChildren])(
    data
  );
};

let timeout;
let currentValue;

function fetchCustomers(value, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;

  function getCustomers() {
    ctsp.getCustomers(value).then((result) => {
      if (currentValue === value) {
        const data = [];
        result.forEach((r) => {
          data.push(r["name"]);
        });
        callback(data);
      }
    });
  }

  timeout = setTimeout(getCustomers, 300);
}

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      rolesList: [],
      value: undefined,
      deptIds: [],
      loading: false,
      cityValue: "",
      provinceList: [],
      cityList: [],
      treeData: [],
      dataSource: [],
    };
  },
  async created() {
    await this.getAuthorityDomainList();
    this.provinceList = await this.getRegionList();
    console.log(this.provinceList);
    this.getList();
  },
  computed: {
    editProvince() {
      let value = "";
      if (this.item && this.item.provinceName) {
        const province = this.provinceList.find(
          (res) => res.name === this.item.provinceName
        );
        if (province) {
          value = province.code;
        }
        this.getCityList(value);
      }
      return value;
    },
    editCity() {
      let value = "";
      if (this.item && this.item.cityName) {
        const city = this.cityList.find(
          (res) => res.name === this.item.cityName
        );
        if (city) {
          value = city.code;
        }
      }
      return value;
    },
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    onSearchCustomer(searchText) {
      fetchCustomers(searchText, (data) => (this.dataSource = data));
    },
    handleProvinceChange(value) {
      this.getCityList(value);
      if (this.cityValue) {
        this.form.setFieldsValue({
          cityId: "",
        });
      }
    },
    handleCityChange(value) {
      this.cityValue = value;
    },
    onClose() {
      this.form.resetFields();
      this.$emit("close", false);
    },
    save() {
      this.form.validateFields((err, values) => {
        if (!err) {
          Object.keys(values).forEach((key) => {
            const str = values[key];
            if (str !== undefined || str !== null) {
              values[key] = str.replace(/\s+/g, "");
            }
          });
          this.loading = true;
          const data = { ...values };
          data.provinceName = this.provinceList.find(
            (res) => res.code === values.provinceId
          ).name;
          data.cityName = this.cityList.find(
            (res) => res.code === values.cityId
          ).name;
          ctsp
            .updateSupplier(data, this.item.id)
            .then(() => {
              this.loading = false;
              this.$message.success(this.$t("page_mdc_setting_edit_success"));
              this.form.resetFields();
              this.$emit("reload");
            })
            .catch(() => {
              this.form.resetFields();
              this.loading = false;
            });
        } else {
          this.loading = false;
        }
      });
    },
    async getCityList(value) {
      this.cityList = await (await rsp.select(value)).data;
    },
    async getRegionList() {
      return await (await rsp.selectByLevel()).data;
    },
    async getList() {
      let result = await crsp.list("CustomerObject");
      this.codeList = result.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    },
    handleSelectChange(val) {
      if (val) {
        this.form.setFieldsValue({ ["code"]: "" });
        //  console.log(11111,this.form.getFieldValue("code"))
        this.codeId = true;
      } else {
        this.codeId = false;
      }
    },
    async getAuthorityDomainList() {
      const { data } = await adsp.getEnableTreeList();
      const tree = tranformTreeShape(data[0]);
      tree.selectable = false;
      this.treeData = [tree];
    },
  },
};
</script>
<style></style>
